export default __webpack_public_path__ + "static/media/(16).2aca97f0.jpg";